/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicyAppliesNotificationArguments } from '../models/BackupPolicyAppliesNotificationArguments';
import { BackupPolicyNotificationArguments } from '../models/BackupPolicyNotificationArguments';
import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments';
import { IssueMutedNotificationArguments } from '../models/IssueMutedNotificationArguments';
import { JobFailedNotificationArguments } from '../models/JobFailedNotificationArguments';
import { JobMetricsReportFailedArguments } from '../models/JobMetricsReportFailedArguments';
import { JobSucceededNotificationArguments } from '../models/JobSucceededNotificationArguments';
import { RansomwareResourceNotificationArguments } from '../models/RansomwareResourceNotificationArguments';
import { RansomwareSnapshotNotificationArguments } from '../models/RansomwareSnapshotNotificationArguments';
import { VaultNotificationArguments } from '../models/VaultNotificationArguments';
import { ViolationsDetectionNotificationArguments } from '../models/ViolationsDetectionNotificationArguments';

export class NotificationArguments {
  'restoreJobFailed'?: JobFailedNotificationArguments;
  'restoreJobSucceeded'?: JobSucceededNotificationArguments;
  'backupJobFailed'?: JobFailedNotificationArguments;
  'backupJobSucceeded'?: JobSucceededNotificationArguments;
  'cloudAccountCreated'?: CloudAccountNotificationArguments;
  'cloudAccountUpdated'?: CloudAccountNotificationArguments;
  'cloudAccountDeleted'?: CloudAccountNotificationArguments;
  'cloudAccountDeactivated'?: CloudAccountNotificationArguments;
  'cloudAccountActivated'?: CloudAccountNotificationArguments;
  'backupPolicyApplied'?: BackupPolicyAppliesNotificationArguments;
  'backupPolicyUnApplied'?: BackupPolicyAppliesNotificationArguments;
  'backupPolicyCreated'?: BackupPolicyNotificationArguments;
  'backupPolicyUpdated'?: BackupPolicyNotificationArguments;
  'backupPolicyDeleted'?: BackupPolicyNotificationArguments;
  'backupVaultCreated'?: VaultNotificationArguments;
  'backupVaultDeleted'?: VaultNotificationArguments;
  'resourceExcludedFromRansomwareDetection'?: RansomwareResourceNotificationArguments;
  'ransomwareDetectionExclusionCanceled'?: RansomwareResourceNotificationArguments;
  'ransomwareDetectedInResource'?: RansomwareResourceNotificationArguments;
  'ransomwareDetectedInSnapshot'?: RansomwareSnapshotNotificationArguments;
  'ransomwareInfectionRemediated'?: RansomwareResourceNotificationArguments;
  'violationsDetected'?: ViolationsDetectionNotificationArguments;
  'violationsResolved'?: ViolationsDetectionNotificationArguments;
  'issueMuted'?: IssueMutedNotificationArguments;
  'issueUnmuted'?: IssueMutedNotificationArguments;
  'jobMetricsReportFailed'?: JobMetricsReportFailedArguments;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreJobFailed",
      "baseName": "restoreJobFailed",
      "type": "JobFailedNotificationArguments",
      "format": ""
    },
    {
      "name": "restoreJobSucceeded",
      "baseName": "restoreJobSucceeded",
      "type": "JobSucceededNotificationArguments",
      "format": ""
    },
    {
      "name": "backupJobFailed",
      "baseName": "backupJobFailed",
      "type": "JobFailedNotificationArguments",
      "format": ""
    },
    {
      "name": "backupJobSucceeded",
      "baseName": "backupJobSucceeded",
      "type": "JobSucceededNotificationArguments",
      "format": ""
    },
    {
      "name": "cloudAccountCreated",
      "baseName": "cloudAccountCreated",
      "type": "CloudAccountNotificationArguments",
      "format": ""
    },
    {
      "name": "cloudAccountUpdated",
      "baseName": "cloudAccountUpdated",
      "type": "CloudAccountNotificationArguments",
      "format": ""
    },
    {
      "name": "cloudAccountDeleted",
      "baseName": "cloudAccountDeleted",
      "type": "CloudAccountNotificationArguments",
      "format": ""
    },
    {
      "name": "cloudAccountDeactivated",
      "baseName": "cloudAccountDeactivated",
      "type": "CloudAccountNotificationArguments",
      "format": ""
    },
    {
      "name": "cloudAccountActivated",
      "baseName": "cloudAccountActivated",
      "type": "CloudAccountNotificationArguments",
      "format": ""
    },
    {
      "name": "backupPolicyApplied",
      "baseName": "backupPolicyApplied",
      "type": "BackupPolicyAppliesNotificationArguments",
      "format": ""
    },
    {
      "name": "backupPolicyUnApplied",
      "baseName": "backupPolicyUnApplied",
      "type": "BackupPolicyAppliesNotificationArguments",
      "format": ""
    },
    {
      "name": "backupPolicyCreated",
      "baseName": "backupPolicyCreated",
      "type": "BackupPolicyNotificationArguments",
      "format": ""
    },
    {
      "name": "backupPolicyUpdated",
      "baseName": "backupPolicyUpdated",
      "type": "BackupPolicyNotificationArguments",
      "format": ""
    },
    {
      "name": "backupPolicyDeleted",
      "baseName": "backupPolicyDeleted",
      "type": "BackupPolicyNotificationArguments",
      "format": ""
    },
    {
      "name": "backupVaultCreated",
      "baseName": "backupVaultCreated",
      "type": "VaultNotificationArguments",
      "format": ""
    },
    {
      "name": "backupVaultDeleted",
      "baseName": "backupVaultDeleted",
      "type": "VaultNotificationArguments",
      "format": ""
    },
    {
      "name": "resourceExcludedFromRansomwareDetection",
      "baseName": "resourceExcludedFromRansomwareDetection",
      "type": "RansomwareResourceNotificationArguments",
      "format": ""
    },
    {
      "name": "ransomwareDetectionExclusionCanceled",
      "baseName": "ransomwareDetectionExclusionCanceled",
      "type": "RansomwareResourceNotificationArguments",
      "format": ""
    },
    {
      "name": "ransomwareDetectedInResource",
      "baseName": "ransomwareDetectedInResource",
      "type": "RansomwareResourceNotificationArguments",
      "format": ""
    },
    {
      "name": "ransomwareDetectedInSnapshot",
      "baseName": "ransomwareDetectedInSnapshot",
      "type": "RansomwareSnapshotNotificationArguments",
      "format": ""
    },
    {
      "name": "ransomwareInfectionRemediated",
      "baseName": "ransomwareInfectionRemediated",
      "type": "RansomwareResourceNotificationArguments",
      "format": ""
    },
    {
      "name": "violationsDetected",
      "baseName": "violationsDetected",
      "type": "ViolationsDetectionNotificationArguments",
      "format": ""
    },
    {
      "name": "violationsResolved",
      "baseName": "violationsResolved",
      "type": "ViolationsDetectionNotificationArguments",
      "format": ""
    },
    {
      "name": "issueMuted",
      "baseName": "issueMuted",
      "type": "IssueMutedNotificationArguments",
      "format": ""
    },
    {
      "name": "issueUnmuted",
      "baseName": "issueUnmuted",
      "type": "IssueMutedNotificationArguments",
      "format": ""
    },
    {
      "name": "jobMetricsReportFailed",
      "baseName": "jobMetricsReportFailed",
      "type": "JobMetricsReportFailedArguments",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotificationArguments.attributeTypeMap;
  }

  public constructor() {
  }
}

